<div
  [id]="'care-provider-' + itemIndex()"
  [ngClass]="{'border-blueberry-3': careproviderUnit().isDigital && !careproviderUnit().isAbroad, 'border-apricot-1': careproviderUnit().isAbroad, 'border-grey-9': !careproviderUnit().isDigital && !careproviderUnit().isAbroad}"
  class="relative rounded-xl bg-white top-container p-4 flex flex-col xl:flex-row justify-between xl:items-stretch gap-4 border"
>
  <div class="image-section flex w-full xl:w-80 xl:basis-80 h-auto aspect-[3/1]">
    <app-search-careprovider-unit-item-img-v3
      [careproviderRouterLink]="careproviderRouterLink()"
      [class]="'test-img-' + itemIndex()"
      [hasImage]="hasImage()"
      [imageUrl]="imageUrl()"
      [isCustomer]="careproviderUnit()?.isCustomer"
      [isPriorityImage]="isPriorityImage()"
      [itemIndex]="itemIndex()"
      [logoUrl]="logoUrl()"
      [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
      [mainSegment]="mainSegment()"
      [name]="careproviderUnit()?.name" [rating]="careproviderUnit()?.rating"
      [reviesCount]="careproviderUnit()?.reviesCount"
      class="w-full xl:w-80 aspect-[3/1]"
      pukas
    ></app-search-careprovider-unit-item-img-v3>
  </div>
  <div class="w-full flex flex-col gap-4">
    <div class="flex flex-col 2xl:flex-row justify-between items-start flex-wrap 2xl:flex-nowrap">
      <div class="info-section w-full flex flex-col gap-1 order-2 2xl:order-1">
        <div class="item-title line-clamp-2">
          <a
            [class]="'test-title-' + itemIndex()"
            [routerLink]="careproviderRouterLink()"
            class="lg font-bold text-green-1 hover:text-apricot-1"
          >
            {{ careproviderUnit().name }}
          </a>
        </div>

        <div class="flex flex-col md:flex-row gap-2 md:gap-4 justify-start md:justify-between items-center">
          @if (careproviderUnit().address && !careproviderUnit().isDigital && address()) {
            <div class="inline-flex items-center flex-row w-full md:w-auto">
              <app-ui-icon
                class="mr-1"
                color="var(--grey-3)"
                name="marker"
                size="sm"
              ></app-ui-icon>
              <a
                (click)="openMap()"
                [class]="'test-address-' + itemIndex()"
                class="text-green-2 text-sm hover:text-green-1"
              >
                {{ address() }}
              </a>
            </div>
          }

          <div class="booking-section flex flex-col w-full md:w-auto">
            @if (showHomepage() || showPhone()) {
              <div class="flex mt-3 gap-2 justify-between xl:justify-start">
                @if (showHomepage()) {
                  <div class="block grow xl:inline-block xl:grow-0">
                    <app-ui-button (click)="openCpruContact()"
                                [eventAction]="
                  eventActionEnum.HSA_CTA_WEBSITE
                "
                                [eventCategory]="eventCategoryEnum.HSA_CTA"
                                [eventLabel]="careproviderUnit().id.toString()"
                                [eventParams]="
                  generateDataLayerParamsClickGA4(
                    eventCategoryEnum.HSA_CTA +
                      ' - ' +
                      eventActionEnum.HSA_CTA_WEBSITE,
                    null,
                    null
                  )
                "
                                appGtmEvent
                                appGtmGa4Event
                                class="grow"
                                color="tertiary"
                                expanded="block"
                                size="sm">
                      <app-ui-icon
                        class="icon"
                        color="var(--green-1)"
                        name="website"
                        size="md"
                      ></app-ui-icon>
                      Hemsida
                    </app-ui-button>
                  </div>
                }

                @if (showPhone()) {
                  <div class="block grow xl:inline-block xl:grow-0">
                    <app-ui-button (click)="openCpruContact()"
                                [eventAction]="
                  eventActionEnum.HSA_CTA_PHONE
                "
                                [eventCategory]="eventCategoryEnum.HSA_CTA"
                                [eventLabel]="careproviderUnit().id.toString()"
                                [eventParams]="
                  generateDataLayerParamsClickGA4(
                    eventCategoryEnum.HSA_CTA +
                      ' - ' +
                      eventActionEnum.HSA_CTA_PHONE,
                    null,
                    null
                  )
                "
                                appGtmEvent
                                appGtmGa4Event
                                class="grow"
                                color="tertiary"
                                expanded="block"
                                size="sm">
                      <app-ui-icon
                        class="icon"
                        color="var(--green-1)"
                        name="phone"
                        size="md"
                      ></app-ui-icon>
                      Telefon
                    </app-ui-button>
                  </div>
                }

              </div>
            }

          </div>
        </div>
      </div>

      @if (careproviderUnit().isDigital || careproviderUnit().isBoosted || careproviderUnit().isAbroad) {
        <app-search-careprovider-unit-item-labels
          [isAbroad]="careproviderUnit().isAbroad"
          [isBoosted]="careproviderUnit().isBoosted"
          [isDigital]="careproviderUnit().isDigital"
          class="block mb-2 2xl:mb-0 order-1 2xl:order-2 w-fit h-8 relative"
        ></app-search-careprovider-unit-item-labels>
      }
    </div>


  </div>
</div>
